import { Component, OnInit } from '@angular/core';
import { AssessmentService } from 'src/app/core/services/assessment.service';
import { CommonService } from 'src/app/core/services/common.service';
import { StorageService } from 'src/app/core/services/storage.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { NotificationComponent } from 'src/app/shared/layouts/notification/notification.component';
import { Router } from '@angular/router';

@Component({
  selector: 'app-historical-assessment',
  templateUrl: './historical-assessment.component.html',
  styleUrls: ['./historical-assessment.component.css']
})
export class HistoricalAssessmentComponent implements OnInit {

  isArabic: any;
  questionnaireList: any;
  isMakerCheckerEnabled: any;
  isChecker: any;
  userData: any;
  modalRef!: BsModalRef;
  modalRefDeactivate!: BsModalRef;
  assessmentDetails: any;
  constructor(private storageService: StorageService, private commonService: CommonService, private route: Router,
    private assessmentService: AssessmentService, private modalService: BsModalService) { }

  ngOnInit(): void {
    this.userData = this.storageService.getSessionStorageData('userDetails');
    this.isMakerCheckerEnabled = this.storageService.getSessionStorageData('isMakerCheckerEnabled');
    this.isChecker = this.storageService.getSessionStorageData('isChecker');
    //console.log('sessionData in assessment: ', this.userData);
    this.isArabic = this.storageService.getSessionStorageData('isArabic');

    const rqstBody = { assessmentUnit: this.userData?.assessmentUnitValue, contactguid: this.userData?.contactguid };
    this.assessmentService.fetchSubmittedQuestionnaires(rqstBody).subscribe((res) => {
      let decryptedData = this.commonService.decryptUsingAES256(res?.data);
      //console.log('get submitted questionnaire list in assessment: ', decryptedData);
      let resp = JSON.parse(JSON.stringify(decryptedData));
      this.questionnaireList = resp.questionnaires;
      //console.log('list of submitted questionnaires: ', this.questionnaireList);
    }, (error: any) => {
      //console.log('server error check: ', error);
      if (error?.body?.error == 'The Assossicated Assessment Entity has deactivated') {
        this.showDeactivationPopup();
      }
    });
  }

  showDeactivationPopup() {
    let pathUrl = 'login';
    let message = '';
    if (this.isArabic) {
      message = '.تم إلغاء تنشيط كيان الاتصال / التقييم';
    } else {
      message = 'Contact/Assessment Entity has been deactivated.';
    }
    const initialState = {
      message: message,
      redirectTo: pathUrl,
      cancelButton: false
    };
    this.modalRefDeactivate = this.modalService.show(NotificationComponent, { ignoreBackdropClick: true, initialState });
  }

  showAssessmentDetails(item: any) {
    /* will add later */
    //console.log(item);
    let rqstBody = {
      questionnaire: item.questionnaireMdeValue,
      assessmentUnit: this.userData?.assessmentUnitValue,
      isChecker: this.isChecker,
      isMakerCheckerEnabled: this.isMakerCheckerEnabled
    };
    this.assessmentService.fetchTotalNoOfQues(rqstBody).subscribe((res) => {
      let decryptedData = this.commonService.decryptUsingAES256(res?.data);
      let resp = JSON.parse(JSON.stringify(decryptedData));
      //console.log('finally number of questions: ', resp);
      if (resp.totalQuestions <= 0) {
        let message;
        if (this.isArabic) {
          message = 'لا يوجد سؤال متاح لهذا التقييم.';
        } else {
          message = 'No question is available for this assessment.';
        }
        let pathUrl = '';
        const initialState = {
          message: message,
          redirectTo: pathUrl
        };
        this.modalRef = this.modalService.show(NotificationComponent, { initialState });
      } else {
        this.assessmentDetails = {
          questionnaireName: item.questionnaireName,
          questionnaireguid: item.questionnaireMdeValue,
          assessmentUnit: item.assessmentUnit.name,
          assessmentunitguid: item.assessmentUnit.value,
          questionnaireAccountGuid: item.questionnaireAccountGuid,
          assessmentratingpreview: item.assessmentratingpreview
        }
        this.storageService.setSessionStorageData('assessmentDetails', this.assessmentDetails);
        // this.route.navigate(['submit-assessment'], { queryParams: { questionnairetype: 'General', action: 'view' } });
        if (resp?.totalEachTypeQuestions[0].name == "General" &&
          resp?.totalEachTypeQuestions[0].totalcount > 0) {
          this.route.navigate(['submit-assessment'], { queryParams: { questionnairetype: 'General', action: 'view' } });
        }
        else if (resp?.totalEachTypeQuestions[1].name == "Inherent Risk" &&
          resp?.totalEachTypeQuestions[1].totalcount > 0) {
          this.route.navigate(['submit-assessment'], { queryParams: { questionnairetype: 'Inherent Risk', action: 'view' } });
        }
        else if (resp?.totalEachTypeQuestions[2].name == "Controls" &&
          resp?.totalEachTypeQuestions[2].totalcount > 0) {
          this.route.navigate(['submit-assessment'], { queryParams: { questionnairetype: 'Controls', action: 'view' } });
        }
        else {
          this.route.navigate(['submit-assessment'], { queryParams: { questionnairetype: 'General', action: 'view' } });
        }
      }
    });
  }

}
